/**
 * Company: SPHMedia
 * Description: [Gets Long Form videos data]
 */

import fetchBHApi from "@helper/fetchBHApi";
import { ENABLE_MEDIA_CONTENT_INFINITE_SCROLL } from "@helper/getEnvVariables";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import { PlaylistType } from "@typings/Playlist.d";
import { useEffect, useState } from "react";

type useLongFormVideoData = {
  playing: LatestVideoResponse;
};

/**
 * Custom React Hook: useLongFormVideo
 * Description: [Gets Long Form videos from bc playlist]
 * @returns data - The data returned by the hook
 */
export default function useLongFormVideo(
  landscapeVideo = false,
  size = 1,
): useLongFormVideoData {
  const [playing, setPlaying] = useState<LatestVideoResponse>({
    id: "",
  } as LatestVideoResponse);

  useEffect(() => {
    const fetchData = async () => {
      let apiUrl = `latest-videos?size=${size}`;
      if (landscapeVideo) {
        apiUrl = `latest-videos-playlist?playlistId=${PlaylistType.LONG_FORM}&size=${size}`;
      }

      try {
        const videos = await fetchBHApi<LatestVideoResponse[]>(apiUrl, "GET");
        const limitedContent = videos[0];
        if (limitedContent.id !== "") {
          setPlaying(limitedContent);
        }
      } catch (error) {
        console.error(
          "[InfiniteScroll] Error fetching long-form video:",
          error,
        );
      }
    };
    if (ENABLE_MEDIA_CONTENT_INFINITE_SCROLL || landscapeVideo) {
      void fetchData();
    }
  }, [landscapeVideo, size]);

  return { playing };
}
